import { c as _c } from "react/compiler-runtime";
import { IcoText16 } from '@onefootprint/icons';
import { Badge, Divider, SearchInput, Truncate } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import Fuse from 'fuse.js';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { NormalizedArtifact } from '../onboarding-data-entry-viewer';
import { categorizeDataValue, formatInlineValue } from '../utils/data-artifact-utils';
import { getFileArtifactIcon } from '../utils/file-artifacts-utils';
type ArtifactViewerNavListProps = {
  fileArtifacts: NormalizedArtifact[];
  dataArtifacts: NormalizedArtifact[];
  onSelectArtifact: (artifact: NormalizedArtifact) => void;
  selectedArtifact: NormalizedArtifact | null;
};
const FUSE_OPTIONS = {
  keys: ['key'],
  threshold: 0.3,
  minMatchCharLength: 1,
  includeScore: true
};
const ArtifactViewerNavList = t0 => {
  const $ = _c(42);
  const {
    fileArtifacts,
    dataArtifacts,
    onSelectArtifact,
    selectedArtifact
  } = t0;
  const {
    t
  } = useTranslation("onboarding-data-entry-viewer");
  const [query, setQuery] = useState("");
  let filteredFiles;
  let t1;
  if ($[0] !== dataArtifacts || $[1] !== fileArtifacts || $[2] !== query) {
    const fileFuse = new Fuse(fileArtifacts, FUSE_OPTIONS);
    const dataFuse = new Fuse(dataArtifacts, FUSE_OPTIONS);
    filteredFiles = query ? fileFuse.search(query).map(_temp) : fileArtifacts;
    t1 = query ? dataFuse.search(query).map(_temp2) : dataArtifacts;
    $[0] = dataArtifacts;
    $[1] = fileArtifacts;
    $[2] = query;
    $[3] = filteredFiles;
    $[4] = t1;
  } else {
    filteredFiles = $[3];
    t1 = $[4];
  }
  const filteredData = t1;
  const hasFiles = filteredFiles.length > 0;
  const hasData = filteredData.length > 0;
  let t2;
  if ($[5] !== selectedArtifact?.key || $[6] !== selectedArtifact?.modifiedAt) {
    t2 = artifact => selectedArtifact?.key === artifact.key && selectedArtifact?.modifiedAt === artifact.modifiedAt;
    $[5] = selectedArtifact?.key;
    $[6] = selectedArtifact?.modifiedAt;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const isSelected = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setQuery("");
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t(_temp3);
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== query || $[12] !== t4) {
    t5 = <div className="px-2 py-2 border-b border-tertiary"><SearchInput value={query} onChangeText={setQuery} onReset={t3} placeholder={t4} size="compact" /></div>;
    $[11] = query;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== filteredFiles || $[15] !== hasFiles || $[16] !== isSelected || $[17] !== onSelectArtifact || $[18] !== t) {
    t6 = hasFiles && <NavGroup label={t(_temp4)} count={filteredFiles.length}>{filteredFiles.map(artifact_0 => <NavItem key={`file-${artifact_0.key}-${artifact_0.modifiedAt}`} artifact={artifact_0} isSelected={isSelected(artifact_0)} onSelect={onSelectArtifact} />)}</NavGroup>;
    $[14] = filteredFiles;
    $[15] = hasFiles;
    $[16] = isSelected;
    $[17] = onSelectArtifact;
    $[18] = t;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== hasData || $[21] !== hasFiles) {
    t7 = hasFiles && hasData && <Divider />;
    $[20] = hasData;
    $[21] = hasFiles;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== filteredData || $[24] !== hasData || $[25] !== isSelected || $[26] !== onSelectArtifact || $[27] !== t) {
    t8 = hasData && <NavGroup label={t(_temp5)} count={filteredData.length}>{filteredData.map(artifact_1 => <NavItem key={`data-${artifact_1.key}-${artifact_1.modifiedAt}`} artifact={artifact_1} isSelected={isSelected(artifact_1)} onSelect={onSelectArtifact} />)}</NavGroup>;
    $[23] = filteredData;
    $[24] = hasData;
    $[25] = isSelected;
    $[26] = onSelectArtifact;
    $[27] = t;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== hasData || $[30] !== hasFiles || $[31] !== query || $[32] !== t) {
    t9 = !hasFiles && !hasData && query && <div className="flex items-center justify-center py-8 text-body-2 text-quaternary">{t(_temp6)}</div>;
    $[29] = hasData;
    $[30] = hasFiles;
    $[31] = query;
    $[32] = t;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] !== t6 || $[35] !== t7 || $[36] !== t8 || $[37] !== t9) {
    t10 = <div className="flex-1 overflow-y-auto">{t6}{t7}{t8}{t9}</div>;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== t10 || $[40] !== t5) {
    t11 = <div className="flex flex-col w-full max-h-48 shrink-0 border-b border-tertiary md:w-[280px] md:max-h-none md:border-b-0 md:border-r">{t5}{t10}</div>;
    $[39] = t10;
    $[40] = t5;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  return t11;
};
const NavGroup = t0 => {
  const $ = _c(12);
  const {
    label,
    count,
    children
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="text-caption-1 uppercase text-tertiary">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== count) {
    t2 = <Badge variant="neutral">{count}</Badge>;
    $[2] = count;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex items-center justify-between px-3 py-2 sticky top-0 bg-primary z-10">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = <div className="flex flex-col gap-0.5 px-2 pb-2">{children}</div>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex flex-col">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
const NavItem = t0 => {
  const $ = _c(43);
  const {
    artifact,
    isSelected,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== artifact) {
    t1 = artifact.artifactType === "file" ? getFileArtifactIcon(artifact) : IcoText16;
    $[0] = artifact;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ArtifactIcon = t1;
  let t2;
  if ($[2] !== artifact.artifactType || $[3] !== artifact.value) {
    t2 = artifact.artifactType === "data" ? categorizeDataValue(artifact.value) : null;
    $[2] = artifact.artifactType;
    $[3] = artifact.value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const category = t2;
  const showValue = category === "inline" || category === "empty";
  let t3;
  if ($[5] !== artifact.value || $[6] !== category || $[7] !== showValue) {
    t3 = category === "empty" ? "-" : showValue ? formatInlineValue(artifact.value) : "";
    $[5] = artifact.value;
    $[6] = category;
    $[7] = showValue;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const displayValue = t3;
  const t4 = !isSelected;
  let t5;
  if ($[9] !== isSelected || $[10] !== showValue || $[11] !== t4) {
    t5 = cx("w-full text-left px-3 py-1.5 rounded-md flex items-center gap-2 transition-colors", {
      "justify-between": showValue,
      "bg-senary/70": isSelected,
      "hover:bg-hover": t4
    });
    $[9] = isSelected;
    $[10] = showValue;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== artifact || $[14] !== onSelect) {
    t6 = () => onSelect(artifact);
    $[13] = artifact;
    $[14] = onSelect;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== showValue) {
    t7 = cx("flex items-center gap-2 min-w-0", {
      "flex-1": showValue
    });
    $[16] = showValue;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = !isSelected;
  let t9;
  if ($[18] !== isSelected || $[19] !== t8) {
    t9 = cx("shrink-0", {
      "text-primary": isSelected,
      "text-tertiary": t8
    });
    $[18] = isSelected;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== ArtifactIcon || $[22] !== t9) {
    t10 = <ArtifactIcon className={t9} />;
    $[21] = ArtifactIcon;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = !isSelected;
  let t12;
  if ($[24] !== isSelected || $[25] !== t11) {
    t12 = cx({
      "text-label-2 text-primary": isSelected,
      "text-body-2 text-tertiary": t11
    });
    $[24] = isSelected;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== artifact.key || $[28] !== t12) {
    t13 = <Truncate as="p" className={t12}>{artifact.key}</Truncate>;
    $[27] = artifact.key;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t10 || $[31] !== t13 || $[32] !== t7) {
    t14 = <div className={t7}>{t10}{t13}</div>;
    $[30] = t10;
    $[31] = t13;
    $[32] = t7;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== displayValue || $[35] !== isSelected || $[36] !== showValue) {
    t15 = showValue && <Truncate as="p" className={cx("text-right flex-1", {
      "text-label-2 text-primary": isSelected,
      "text-body-2 text-primary": !isSelected
    })}>{displayValue}</Truncate>;
    $[34] = displayValue;
    $[35] = isSelected;
    $[36] = showValue;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t14 || $[39] !== t15 || $[40] !== t5 || $[41] !== t6) {
    t16 = <button type="button" className={t5} onClick={t6}>{t14}{t15}</button>;
    $[38] = t14;
    $[39] = t15;
    $[40] = t5;
    $[41] = t6;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
};
export default ArtifactViewerNavList;
function _temp(r) {
  return r.item;
}
function _temp2(r_0) {
  return r_0.item;
}
function _temp3($) {
  return $.searchPlaceholder;
}
function _temp4($_0) {
  return $_0.fileArtifacts;
}
function _temp5($_1) {
  return $_1.dataArtifacts;
}
function _temp6($_2) {
  return $_2.noSearchResults;
}